// extracted by mini-css-extract-plugin
module.exports = {"msg":"styles__msg__3ttXX","state":"styles__state__2le6c"};